<template>
  <div>
    <v-toolbar dark color="teal">
      <v-btn icon class="hidden-xs-only" @click="back()">
        <v-icon>arrow_back</v-icon>
      </v-btn>
      <v-toolbar-title class="white--text">รายการวิชาที่เปิดใช้งาน</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-title class="subheading white--text">ปีการศึกษาที่ {{ academicYear.semesterYear }}</v-toolbar-title>
    </v-toolbar>
  	<v-card>
      <v-card-title>
        <v-text-field
          v-model="pagination.q"
          append-icon="search"
          label="ค้นหา"
          single-line
          hide-details
        ></v-text-field>
        <v-spacer></v-spacer>
        <v-tooltip left v-if="hasAccess(allowedRoles)">
          <v-btn color="teal" slot="activator" dark fab @click="addItem()">
            <v-icon>playlist_add</v-icon>
          </v-btn>
          <span>เพิ่มรายวิชา</span>
        </v-tooltip>
      </v-card-title>
      <v-data-table
        :loading="loading"
        :headers="headers"
        :items="items"
  			:total-items="pagination.totalItems"
        :pagination.sync="pagination"
      >
        <template slot="items" slot-scope="props">
          <td class="text-xs-center">{{ ((pagination.page - 1) * pagination.rowsPerPage) + props.index + 1 }}</td>
          <td class="text-xs-left">{{ props.item.subject.code }}</td>
          <td class="text-xs-left">{{ props.item.subject.nameTh }}</td>
          <td class="text-xs-left">{{ props.item.subject.nameEn }}</td>
          <td class="text-xs-left">{{ props.item.subject.subjectType | subjectType }}</td>
          <td class="text-xs-left">{{ props.item.courseType | courseType }}</td>
          <td class="layout text-xs-right">
            <v-tooltip left>
              <v-btn icon class="mx-2" slot="activator" @click="viewItem(props.item)">
                <v-icon color="teal">pageview</v-icon>
              </v-btn>
              <span>ดูข้อมูล {{ props.item.subject.code }}</span>
            </v-tooltip>
            <v-tooltip left>
              <v-btn icon class="mx-2" slot="activator" @click="viewSection(props.item)">
                <v-icon color="deep-purple">group</v-icon>
              </v-btn>
              <span>กลุ่มใหญ่</span>
            </v-tooltip>
            <v-tooltip left v-if="hasAccess(allowedRoles)">
              <v-btn icon class="mx-0" slot="activator" @click="deleteItem(props.item)">
                <v-icon color="red">delete</v-icon>
              </v-btn>
              <span>ลบ {{ props.item.subject.code }}</span>
            </v-tooltip>
          </td>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          Your search for "{{ pagination.q }}" found no results.
        </v-alert>
      </v-data-table>
      <div class="text-xs-center pt-2">
        <v-pagination v-model="pagination.page" :length="pages" :total-visible="7"></v-pagination>
      </div>

      <component :is="formDialog" :dialog="dialog" :action="action" :academicYearId="academicYearId" :item="selectedItem" :title="title" :allowedRoles="hasAccess(allowedRoles)" @dialog="dialog = $event"></component>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { hasAccessMixin } from '@/mixins/hasAccessMixin'
import swal from 'sweetalert2'
import ActiveCourseFormDialog from './formDialog.vue'

export default {
  props:['academicYearId'],
  mixins: [ hasAccessMixin ],
  components: {
    ActiveCourseFormDialog
  },
	data () {
    return {
      allowedRoles: ['ROLE_ADMIN', 'ROLE_SERVICE'],
      action: null,
      dialog: false,
      title: {
        icon: null,
        text: null
      },
      formDialog: null,
      loading: false,
      headers: [
        { text: '#', sortable: false, align: 'center', width: '100' },
        { text: 'รหัสวิชา', align: 'left', sortable: true, value: 'subject.code' },
        { text: 'ชื่อวิชา (ไทย)', align: 'left', sortable: true, value: 'subject.nameTh' },
        { text: 'ชื่อวิชา (อังกฤษ)', align: 'left', sortable: true, value: 'subject.nameEn' },
        { text: 'กลุ่มวิชา', align: 'left', sortable: true, value: 'subject.subjectType' },
        { text: 'หลักสูตร', align: 'left', sortable: true, value: 'courseType' },
        { sortable: false }
      ],
      pagination: {
        q: '',
        sortBy: 'subject.code',
        page: 1,
        rowsPerPage: 10,
        descending: true,
        totalItems: 0,
        academicYearId: this.academicYearId
      },
      items: [],
      selectedItem: {}
    }
  },
  mounted () {
    this.reload()
    this.$store.dispatch('person/fetchPersonItems')
    this.$store.dispatch('fetchRooms')
  },
  computed: {
    ...mapGetters({
        academicYear: 'academicYear/academicYear'
    }),
    pages () {
      if (this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      ) return 0

      return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage)
    }
  },
  methods: {
    addItem () {
      this.reset()
      this.title.icon = 'add'
      this.title.text = 'เพิ่มรายการ'
      this.formDialog = 'active-course-form-dialog'
      setTimeout(()=>{this.dialog = true}, 300)
    },
    back () {
      // this.$router.go(-1)
      this.$router.push({ path: '/management/course/academicYears' })
    },
    deleteItem (item) {
      swal({
        title: 'คุณแน่ใจ?',
        text: "คุณจะไม่สามารถเรียกคืนข้อมูลได้อีก!",
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'ยกเลิก',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ใช่, ฉันต้องการลบข้อมูลนี้!'
      }).then((result) => {
        // console.log('swal', result.value)
        if (result.value) {
          this.$store.dispatch('activeCourse/delete', item)
            .then((response) => {
                console.log('reload:', response )
                this.reload()
              }).catch((error) => {
                swal('Error!', error.message, 'error')
              })
          swal(
            'ลบรายการ!',
            'คุณได้ทำการลบรายการเรียบร้อยแล้ว',
            'success'
          )
        }
      })
    },
    viewItem (item) {
      this.title.icon = 'chrome_reader_mode'
      this.title.text = 'แสดงรายการ'
      this.selectedItem = item
      this.formDialog = 'active-course-form-dialog'
      setTimeout(()=>{this.dialog = true}, 300)
    },
    viewSection (item) {
      this.$store.dispatch('activeCourse/setActiveCourse', item)
      this.$router.push({ name: 'section', params: { activeCourseId: item.id, allowedRoles: this.hasAccess(this.allowedRoles) }})
    },
    reload () {
      this.loading = true
      this.$store.dispatch('activeCourse/loadItemsAsPage', this.pagination)
        .then((response) => {
          // console.log('reload:', response )
          this.pagination.totalItems = response.data.totalItems
          this.items = response.data.items
          this.loading = false
        }).catch((error) => {
          this.loading = false
          swal('Error!', error.message, 'error')
        })
    },
    reset () {
      this.selectedItem = {
        academicYear: { id: this.academicYearId },
        subject: {},
        courseType: {},
        instructor: {}
      }
    }
  },
  watch: {
    'pagination.rowsPerPage' () {
      this.reload()
    },
    'pagination.q' () {
      this.reload()
    },
    'pagination.page' () {
      this.reload()
    },
    'pagination.descending' () {
      this.reload()
    },
    dialog (val) {
      if(!val) {
        setTimeout(()=>{
          this.reset()
          this.formDialog = null
        }, 300)
        this.reload()
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/management/course/activeCourse/index.vue